import { useEffect, useState } from 'react';

import classNames from 'classnames';

import HeartIcon from '@/material-icons/400-24px/heart-fill.svg?react';

import { apiRequestGet } from 'mastodon/api';

interface DonationInfo {
  enabled: boolean;
  url: string;
  title: string;
}

export const DonationBanner: React.FC<{ variant?: 'wide' | 'compact' }> = ({
  variant = 'wide',
}) => {
  const [data, setData] = useState<DonationInfo | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiRequestGet<DonationInfo>('v1/donation_progress')
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch(() => {
        if (!cancelled) setData(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data || !data.enabled || !data.url) return null;

  return (
    <a
      className={classNames('donation-banner', `donation-banner--${variant}`)}
      href={data.url}
      target='_blank'
      rel='noopener noreferrer'
    >
      <span className='donation-banner__icon' aria-hidden='true'>
        <HeartIcon />
      </span>
      <span className='donation-banner__title'>{data.title}</span>
      <span className='donation-banner__cta' aria-hidden='true'>
        Donate →
      </span>
    </a>
  );
};
